'use client'

import React from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/Card'
import RichText from '@/components/RichText'

interface UICardBlockProps {
  title?: string
  description?: string
  content?: any[] // Rich text content
  footer?: any[] // Rich text footer content
  showHeader?: boolean
  showFooter?: boolean
  className?: string
}

export const UICardBlock: React.FC<UICardBlockProps> = ({
  title,
  description,
  content,
  footer,
  showHeader = true,
  showFooter = false,
  className,
}) => {
  return (
    <Card className={className}>
      {showHeader && (title || description) && (
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
      )}
      
      {content && content.length > 0 && (
        <CardContent>
          <RichText content={content} />
        </CardContent>
      )}
      
      {showFooter && footer && footer.length > 0 && (
        <CardFooter>
          <RichText content={footer} />
        </CardFooter>
      )}
    </Card>
  )
}

export default UICardBlock